<div *ngFor="let item of data" style="display: inline-block">
	<div *ngIf="item">
		<div class="md-chip" [ngClass]="item.cssClass">
			{{ item.value }}
		</div>
	</div>
</div>
